module.exports = __webpack_public_path__ + "img/icon-Back.b14d0041.png";